import { render, staticRenderFns } from "./ServiceProviderDetailComponentUnAuth.vue?vue&type=template&id=1b285b2f&"
import script from "./ServiceProviderDetailComponentUnAuth.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderDetailComponentUnAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports